/**
 * @file ServiceFormModel
 * @author fuqiang15
 */
import FormModel from '@baidu/ve-ria/views/FormModel';
import {map, isString} from 'lodash';
import {purify} from '@baidu/ve-ria/utils/lang';

export default class ServiceBaseFormModel extends FormModel {

    serviceType = null;

    serviceDetail = {};

    appDatasource = [];

    createForFixedAppId = null;

    /**
     * @override
     */
    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            text: ''
        }
    ];

    serviceTypeMap = this.getConstantMap('APP_SERVICE_TYPE');
    pageTypeMap = this.getConstantMap('PAGE_TYPE');

    adaptData(data) {
        let isEdit = this.pageType === 'edit';
        if (isEdit) {
            this.setAppDatasourceFromDetail(data);
        }
        if (data.data && isString(data.data)) {
            try {
                data.data = JSON.parse(data.data);
            }
            catch (e) {
                // noop
            }
        }
        if (!data.data) {
            data.data = {};
        }
        this.serviceDetail = data;
        const status = data.status || data.serviceStatus;
        if (status === 'DRAFT' && isEdit) {
            let type = this.serviceType.replace(/^\w/, ch => ch.toUpperCase());
            this.updateRequester = this.api[`appService${type}DraftUpdate`] || this.updateRequester;
        }
        return super.adaptData(data);
    }

    init() {
        super.init();

        if (!this.serviceType) {
            throw new Error('serviceType must be set!');
        }
        this.setRequesters();
        this.setCrumbData();
        let appId = this.getRouteParams().appId;
        if (this.crumbData && appId) {
            this.crumbData[0].to = `/app/${appId}/service/list`;
        }
        if (this.pageType === 'create') {
            this.createForFixedAppId = appId;
            this.formData.appId = appId;
        }

        this.isAdmin = !!this.getRouteMeta().isAdmin;
    }

    // 编辑页面，直接从详情来生成应用列表
    setAppDatasourceFromDetail({appName, appId}) {
        this.appDatasource = [{label: appName, value: appId}];
    }

    async requestAppList() {
        if (this.appListRequester) {
            let appList = await this.appListRequester({
                pageNo: 1,
                pageSize: 1000
            });
            this.appDatasource = map(appList.result, ({id: value, name: label}) => ({label, value}));
        }
    }

    setRequesters() {
        this.appListRequester = this.api.appList;
        let type = this.serviceType.replace(/^\w/, ch => ch.toUpperCase());
        if (this.pageType === 'create') {
            this.createRequester = this.api[`appService${type}Create`] || this.api.appServiceCreate;
        }
        else if (this.pageType === 'edit') {
            // DRAFT 更新是另外一个新的接口
            this.updateRequester = this.api[`appService${type}Update`] || this.api.appServiceUpdate;
            this.detailRequester = this.api[`appService${type}Detail`] || this.api.appServiceDetail;
            this.id = this.getRouteParams().serviceId;
        }
        else if (this.pageType === 'detail') {
            this.detailRequester = this.api[`appService${type}Detail`] || this.api.appServiceDetail;
            this.id = this.getRouteParams().serviceId;
        }
    }

    setCrumbData() {
        let typeText = this.serviceTypeMap[this.serviceType.toUpperCase()];
        let actionText = this.pageTypeMap[this.pageType];
        this.crumbData[1].text = `${actionText}${typeText}`;
    }

    prepareData(data) {
        data = purify(super.prepareData(data));
        if (this.pageType === 'edit') {
            return {
                ...data,
                id: this.getRouteParams().serviceId
            };
        }
        return data;
    }
}

